const NAME_MAX_LENGTH = 30;

export default function validateUUID(uuidToValidate) {
  const re = new RegExp(
    "^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}$"
  );

  return re.test(uuidToValidate);
}

function truncateName(name, maxLength = NAME_MAX_LENGTH) {
  if (!name || typeof name !== "string") return "";
  return name.length > maxLength ? `${name.slice(0, maxLength)}…` : name;
}

function formatPhone(phoneNumber) {
  if (!phoneNumber) return phoneNumber;

  let cleaned = ("" + phoneNumber).replace(/\D/g, "");

  let match = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
  }

  match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }

  match = cleaned.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "+" + match[1] + " (" + match[2] + ") " + match[3] + "-" + match[4];
  }

  match = cleaned.match(/^(\d{1,3})(\d{2,4})(\d{2,4})(\d{2,4})$/);
  if (match) {
    return "+" + match[1] + " " + match[2] + " " + match[3] + " " + match[4];
  }

  return phoneNumber;
}

function isValidEmail(email) {
  if (/^\w+([_+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(email)) {
    return true;
  } else {
    return false;
  }
}

function isValidPassword(password) {
  const passwordRegEx =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/i;

  if (passwordRegEx.test(password)) {
    return true;
  } else {
    return false;
  }
}

function isValidPhoneNumber(phone) {
  const basicNumberCheck =
    /^[0-9]?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  return phone.match(basicNumberCheck) !== null;
}

function isValidUSZip(zip) {
  return /^\d{5}(-\d{4})?$/.test(zip);
}

function toTitleCase(s) {
  return s
    .toLowerCase()
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}

export {
  validateUUID,
  truncateName,
  formatPhone,
  isValidEmail,
  isValidPassword,
  isValidPhoneNumber,
  isValidUSZip,
  toTitleCase,
};
